"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var normalizeTime = function normalizeTime(t) {
  return isFinite(t) ? t + "ms" : t;
};

exports.default = normalizeTime;